
import { css } from 'lit';
export default css`
.icon-navigation {
  display: flex;
  flex-direction: column;
}

  @media (min-width: 1024px) {

  .icon-navigation--horizontal {
    flex-direction: row;
  }
}

  @media (min-width: 1024px) {

  .icon-navigation--horizontal {
    align-items: flex-start;
  }
}

  @media (min-width: 1024px) {

  .icon-navigation--horizontal.icon-navigation--secondary {
    align-items: center;
  }
}

  .icon-navigation--dropdown {
  display: flex;
}

  .icon-navigation--always-horizontal {
  flex-direction: row;
}

  .icon-navigation--always-horizontal {
  align-items: flex-start;
}

  @media (min-width: 1024px) {

  .icon-navigation--item {
    display: inline-block;
  }
}

  .icon-navigation--link {
  padding-left: 1rem;
  padding-right: 1rem;
}

  .icon-navigation--link {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

  .icon-navigation--separator:first-child:after {
      content: "";
      width: 1px;
      height: 2rem;
      background: #A4A7AB;
      position: absolute;
      right: 0;
      bottom: 0;
    }

  .icon-navigation__dropdown {
  height: 0.75rem;
}

  .icon-navigation__dropdown {
  align-self: center;
}

  .icon-navigation__dropdown {
    margin-left: 6px;
    margin-top: 1px;
    width: 14px;
  }

  .icon-navigation__dropdown--rotate {
  margin-top: 0.25rem;
}

  .icon-navigation__dropdown--rotate {
  --tw-rotate: 180deg;
  transform: var(--tw-transform);
}

  .icon-navigation__dropdown--rotate {
  transform: var(--tw-transform);
}

  .icon-navigation__dropdown--rotate {
      transform: rotate(180deg); /* quick workaround to move forward as this is not working */
    }

  .icon-navigation__language {
    display: flex;
    align-items: center;
    margin-left: 13px;
  }

  .icon-navigation__language .icon-navigation__dropdown {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  .icon-navigation__language .goog-te-gadget-simple {
      display: flex;
      align-items: center;
    }

  .icon-navigation__language .goog-te-gadget-simple > span {
        display: flex;
      }

  .icon-navigation__language .goog-te-gadget span a > * {
            display: none;
          }

  .icon-navigation__language .goog-te-gadget span a > span:first-child {
            display: block;
          }

  .icon-navigation__language .goog-te-menu-value {
  font-family: Lato, sans-serif;
}

  .icon-navigation__language .goog-te-menu-value {
  font-size: 1.125rem;
}

  .icon-navigation__language .goog-te-menu-value {
  font-weight: 700;
}

  .icon-navigation__language .goog-te-menu-value {
  line-height: 1.5;
}

  .icon-navigation__language .goog-te-menu-value {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

  @media (min-width: 1024px) {

  .icon-navigation__language .goog-te-menu-value {
    font-size: 1.25rem;
  }
}

  .icon-navigation__language .goog-te-menu-value {
      display: flex;
    }

  .icon-navigation__language .goog-te-menu-value > * {
        display: none;
      }

  .icon-navigation__language .goog-te-menu-value > span:first-child {
        display: block;
      }

  .icon-navigation__language .goog-te-gadget-icon {
      height: 19px;
      margin-right: 0.5rem;
    }

  .icon-navigation.icon-navigation--hp .icon-navigation__language  {
      color: #FFFFFF;
    }

  .icon-navigation.icon-navigation--hp .icon-navigation__language .icon-navigation__dropdown, .icon-navigation.icon-navigation--hp .icon-navigation__language .goog-te-menu-value {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .icon-navigation--social {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

  .icon-navigation--social {
  max-width: 24rem;
}

  .icon-navigation--social {
  flex-direction: row;
}

  .icon-navigation--social {
  justify-content: space-between;
}

  .icon-navigation--horizontal-grid {
  display: grid;
}

  .icon-navigation--horizontal-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

  .icon-navigation--horizontal-grid {
    -moz-column-gap: 1rem;
         column-gap: 1rem;
}

  @media (min-width: 768px) {

  .icon-navigation--horizontal-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

  @media (min-width: 768px) {

  .icon-navigation--horizontal-grid {
      -moz-column-gap: 2rem;
           column-gap: 2rem;
  }
}

  @media (min-width: 1366px) {

  .icon-navigation--horizontal-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

  @media (min-width: 1366px) {

  .icon-navigation--horizontal-grid {
      -moz-column-gap: 3rem;
           column-gap: 3rem;
  }
}

  .icon-navigation--icon-grid .icon-navigation--item {
  border-bottom-width: 1px;
}

  .icon-navigation--icon-grid .icon-navigation--item {
  --tw-border-opacity: 1;
  border-color: rgba(242, 242, 242, var(--tw-border-opacity));
}

  .icon-navigation--hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

  .icon-navigation--alerts {
  margin-top: 0px;
  margin-bottom: 0px;
}

  .icon-navigation--alerts {
  border-bottom-width: 1px;
}

  .icon-navigation--alerts {
  border-style: solid;
}

  .icon-navigation--alerts {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}

  .icon-navigation--alerts {
  padding-top: 0px;
  padding-bottom: 0px;
}

  .icon-navigation--alerts {
  padding-left: 1.5rem;
}

  .icon-navigation--alerts {
  padding-bottom: 2rem;
}

  @media (min-width: 768px) {

  .icon-navigation--alerts {
    flex-direction: row;
  }
}

  @media (min-width: 768px) {

  .icon-navigation--alerts {
    align-items: center;
  }
}

  @media (min-width: 768px) {

  .icon-navigation--alerts {
    padding-left: 2.5rem;
  }
}

  @media (min-width: 768px) {

  .icon-navigation--alerts {
    padding-bottom: 0px;
  }
}

  @media (min-width: 1024px) {

  .icon-navigation--alerts {
    flex-direction: row;
  }
}

  @media (min-width: 768px) {

  .icon-navigation--alerts {
      min-height: 55px
  }
    }

  .icon-navigation--alerts .icon-navigation--item {
  padding-bottom: 0.75rem;
}

  @media (min-width: 768px) {

  .icon-navigation--alerts .icon-navigation--item {
    margin-right: 1rem;
  }
}

  @media (min-width: 768px) {

  .icon-navigation--alerts .icon-navigation--item {
    margin-right: 1.5rem;
  }
}

  @media (min-width: 768px) {

  .icon-navigation--alerts .icon-navigation--item {
    padding-bottom: 0px;
  }
}

  .icon-navigation--location-card {
  margin-top: auto;
}

  .icon-navigation--location-card {
  padding: 0px;
}

  .icon-navigation--location-card li:not(:last-child) {
  position: relative;
}

  .icon-navigation--location-card li:not(:last-child) {
  padding-right: 0.75rem;
}

  .icon-navigation--location-card li:not(:last-child) .btn__link__icon {
  margin-top: 0px;
}

  .icon-navigation--secondary {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

  .icon-navigation__label {
  margin-left: 0.5rem;
}

  .icon-navigation__label {
  font-size: 0.8125rem;
}

  .icon-navigation__label {
  font-weight: 700;
}

  .icon-navigation__label {
  text-transform: uppercase;
}

  .icon-navigation__label {
  --tw-text-opacity: 1;
  color: rgba(117, 118, 119, var(--tw-text-opacity));
}

  @media (min-width: 768px) {

  .icon-navigation__label {
    font-size: 0.875rem;
  }
}

  @media (min-width: 1024px) {

  .icon-navigation__label {
    margin-left: 1rem;
  }
}

  .icon-navigation--hp {

  }

  .icon-navigation.benefits-grid {
    gap: 25px;
  }

  .icon-navigation.benefits-grid li {
      aspect-ratio: 1 / 1;
      height: 100%;
      width: 100%;
      box-shadow: 0 0 10px #ccc;
    }

  .icon-navigation.benefits-grid hf-link-button {
      height: 100%;
      width: 100%;
    }
`;